export const T = {
  en_GB: {
    remove: "Remove",
    description: "Description",
    descriptionPlaceholder: "Description...",
    amountPlaceholder: "Amount...",
    amount: "Amount",
    type: "Type",
    isin: "ISIN",
    addAsset: "Add Asset",
    addIsin: "Batch Add assets by ISIN",
    noItemsYetButtons: "No items added yet. Click the buttons above to add.",
    fieldLabels: {
      cash_savings: "Cash & Savings",
      money_market: "Money Market Funds",
      stocks_funds: "Stocks & Funds",
      bonds: "Bonds & Fixed Income",
      pension_assets: "Pension Assets",
      primary_residence: "Primary Residence",
      investment_property: "Investment Property",
      other_assets: "Other Assets",
    },
  },
  nb_NO: {
    remove: "Fjern",
    description: "Beskrivelse",
    descriptionPlaceholder: "Beskrivelse...",
    amountPlaceholder: "Beløp...",
    amount: "Beløp",
    type: "Type",
    isin: "ISIN",
    addAsset: "Legg til eiendel",
    addIsin: "Legg til flere eiendeler med ISIN",
    noItemsYetButtons: "Ingen poster lagt til ennå. Klikk på knappene over for å legge til.",
    fieldLabels: {
      cash_savings: "Kontanter og sparepenger",
      money_market: "Pengemarkedsfond",
      stocks_funds: "Aksjer og fond",
      bonds: "Obligasjoner og rentepapirer",
      pension_assets: "Pensjonsmidler",
      primary_residence: "Primærbolig",
      investment_property: "Investeringseiendom",
      other_assets: "Andre eiendeler",
    },
  },
} as const;
